module.exports = __webpack_public_path__ + "static/img/youshouzhi.46dbe582.svg";